export enum LogicError {
  Test = -1,
  None = 0,
  RecordIsReferenced = 1,
  CannotChangeDealerStatus,
  UserWasAlreadyAdded,
  CannotDeleteApplication,
  CardDeclined,
  EmailAlreadyInUse,
  CannotAddCompensationToOwn,
  FailedToPerformCashierPayment,
  AttendeeHasErrors,
  UserAlreadyHasRole,
  UserAlreadyAssignedToDepartment,
  AssistanceRequestAlreadySubmitted,
  AssistanceRequestNotFound,
  UserHasNotRegistered,
  CannotTargetSelf,
  IncorrectPassword,
  PaymentFailed,
  ChildLimitExceeded,
  InvalidAttendanceType,
  RegistrationIsFull,
  ProductNotAvailable,
  BadgeArtLimitReached,
  InvalidBadgeArt,
  InvalidConvention,
  EmergencyContactRequired,
  RegistrationClosed,
  ChildrenNotAllowed,
  TooManyChildren,
  ParentCannotVolunteer,
  OAuthMissingToken,
  OAuthInvalidScope,
  OAuthInvalidRedirectURI,
  DealerAlreadyAdded,
  InvalidPaymentProcessor,
  CannotUpdateDateOfBirth,
  NotDepartmentLead,
  DuplicateOrderNumber,
  GatewayOperationNotSupported,
  CannotRedeemVoucherNegative,
  InvalidVoucher,
  GrantWithRefIdAlreadyExists,
  RegistrationCategoryAlreadyExists,
  RefundQuantityExceedsRemaining,
  InvalidRefundRequestStatus,
  DataOutOfSync,
  RefundOperationFailed,
  InvalidRefundAmount,
  VoucherAlreadyRedeemed,
  OrderNotPaid,
  VoucherCodeExists,
  CannotDeletePaidFee,
  NoRefundItemsProvided,
  EventStoreCannotUseCategory,
  OrderCannotBeCancelled,
  InsufficientStock,
  SecondFactorPhoneInUse,
  InvalidFactorIdOrVerification,
  MissingRequiredProductOption,
  UnknownProductOption,
  MustProvideSelectOption,
  InternalOption,
  AgeRestrictedProduct,
  RoleRestrictedProduct,
  ProductNoMultipleTax,
  WrongPlatformFeeAssignment,
  RaffleAlreadyClosed,
  ProductInAnotherRaffle,
  RaffleTicketRescinded,
  AlreadyRedeemedError,
  RegistrationNotDeletable,
  GeoCodingError,
  TooFrequentEmailChange,
  DealerAreaClosed,
  CannotUpdateVolunteerOption,
  NoRegistrationGrantTransfer,
  TargetEmailNotFound,
  TargetRegistrationHasGrant,
  VolunteerAlreadyAssigned,
  DigitalGrantNotOwnedError,
  OrderIsPaid,
  NotAVendor,
  VendorIsNotApproved,
  SessionAlreadyVerified,
  DateOfBirthMissing,
  IdentityInputMissing,
  RequiredIdentityMissing,
  AgeVerification,
  CanNotUpdateVerifiedInformation,
  IdentitySessionAlreadyClaimed,
  IdentitySessionNotVerified,
  CannotOversellProduct,
  OrderAlreadyPaid,
  TicketAlreadyBought,
  NoTicketGroupsAvailable,
  ProductStockTooSmall,
  TooManyTickets,
  ProductRequiresGrant,
  VolunteerClosed,
  DealersClosed,
  ProductVolumeError,
  AddonsCanNotHaveAddonsError,
  AddonItselfError,
  AddonRegistrationError,
  UserDoesNotHaveRole,
  ExportRequestAlreadyCreated,
  ExportIsExpired,
  ExportRequestAlreadyApproved,
  ExportRequestIsRejected,
  ExportRequestNotApproved,
  DirectApprovalNotAllowed,
  ProductAlreadyInOrder,
  BadPaginationToken,
  AddonAlreadyExistsError,
  CannotRemoveAddonFromCart,
  ExportUserApprovedSelf,
  ApplicationNotGranted,
  InvalidOptionValue,
  InternalRegistrationFlag,
  VoucherProductRestricted,
  EmptyCart,
  OutstandingBalance,
  CategoryAssignedToDealerArea,
  DiscourseSignatureError,
  DiscourseMissingNonce,
  OptionIncorrectSource,
  RequestEntityTooLarge,
  CantTransferBadgePrinted,
  ProductNotFound,
  InvalidImage,
  ImageFormatNotSupported,
  ProductGrantQuantityLimit,
  RefundNoAction,
  NoDeleteRegistrationCategory,
  TransferDisabled,
  VoucherCannotBeUsedWithOtherVouchers,
  InvalidEmailDomain,
  InvalidEmailSender,
  OrderGrantError,
  InternalRole,
  UserMissingPermissions,
  RefundsDisabled,
  VoucherExpired,
  TooManyAssistants,
  IncorrectUser,
  OptionTypeChange,
  ApplicationAlreadyApproved,
  DealerNotAdmin,
  InvalidAddonDealerRequest,
  TemplateCannotBeParsed,
  TemplateRequired,
  TemplateVariablesMissing,
  NotAllowedToEditRegisterEmailTemplate,
  ModelOverLimit,
  OverSublimit,
  InvalidExpiration,
  InvalidDeviceType,
  DeviceAlreadyRegistered,
  QuikTicketDisabled,
  PaymentGatewayNotSetUp,
  PaymentGatewayValidationWouldViolate,
  PaymentGatewayApiCallFailed,
  PaymentGatewayResponseIncomplete,
  UsernameTaken,
  TaxMustBePercent,
  HotelReleaseGroupEntriesClosed,
  HotelReleaseEntryNotEligible,
  HotelIntegrationManualSyncNotAllowedError,
  HotelReservationTransferNotAllowedError,
  CannotUpdateProductOption,
  DealerOptionLockedError,
  RoleInviteExpired,
  RoleInviteMaxUses,
  ProductWithAddonsQuantityError,
  OnlySearchOrFilter,
  OwningAccountNoRegistration,
  CannotRequestDeleteSelf,
  CannotDeleteAdmin,
  DeletionRequestExists,
  UserDoesNotExist,
  NoPendingDeletionRequest,
  BadTaskState,
  NoUsernameError,
  NoEmailError,
  BadgeNameIsRequired,
  SubAccountRestricted,
  UnderageProfile,
  ExportRequestAlreadyExists,
  NoDataToExportError,
  VendorAddonMustBeInSameCategory,
  CannotClearBeforeConEnd,
  MalformedRequest,
  NoUpgradePath,
  AttendeesCannotEditOIO,
  CannotDirectEditRegOIO,
}

export enum AccessError {
  Test = 0,
  MissingCredentials = 1,
  InvalidAuthHeader = 2,
  InvalidCredentials = 3,
  TokenNotBelongToUser = 4,
  RedirectTokenNotFound = 5,
  BannedFromDealing = 6,
  UnauthorizedBadgeData = 7,
  UserNotAllowedDiscount = 8,
  DiscountNotBelongToProduct = 9,
  UserNotDepartmentLead = 10,
  BannedFromVolunteering = 11,
  CannotChangeOwnRoles = 12,
  CannotChangeAdminRole = 13,
  UserNotAllowedAction = 14,
  GatewayNotFound = 15,
  EndpointRequiresRegisteredDevice = 16,
  NoPermissionToAccessCategory = 17,
  MissingPermissions = 18,
  MalformedSupportToken = 19,
  SupportTokenIPMismatch = 20,
  InvalidSupportToken = 21,
  UnknownDealerToken = 22,
  MissingQuickTicketPermissions = 23,
  ConventionHostMismatch = 24,
  DealerRequestNotFound = 25,
  UnauthorizedOAuthScopes = 26,
}

export const enum AuthError {
  CSRFMissingHeader = -1000,
  CSRFMissingCookie = -999,
  CSRFMismatch = -998,

  NotAuthenticated = -1,
  IncorrectLogin,
  NotVerified,
  UnderReview,
  PasswordResetRequired,
  Banned,
  MaintenanceMode,

  // 2FA
  SecondFactorMissing = 1000,
  SecondFactorInvalid = 1001,

  // OAuth
  Invalid = 2000,
  Expired,
  Revoked,
}

type JoiValidationRule =
  | 'alternatives.all'
  | 'alternatives.any'
  | 'alternatives.match'
  | 'alternatives.one'
  | 'alternatives.types'
  | 'any.custom'
  | 'any.default'
  | 'any.failover'
  | 'any.invalid'
  | 'any.only'
  | 'any.ref'
  | 'any.required'
  | 'any.unknown'
  | 'array.base'
  | 'array.excludes'
  | 'array.hasKnown'
  | 'array.hasUnknown'
  | 'array.includes'
  | 'array.includesRequiredBoth'
  | 'array.includesRequiredKnowns'
  | 'array.includesRequiredUnknowns'
  | 'array.length'
  | 'array.max'
  | 'array.min'
  | 'array.orderedLength'
  | 'array.sort'
  | 'array.sort.mismatching'
  | 'array.sort.unsupported'
  | 'array.sparse'
  | 'array.unique'
  | 'binary.base'
  | 'binary.length'
  | 'binary.max'
  | 'binary.min'
  | 'boolean.base'
  | 'date.base'
  | 'date.format'
  | 'date.greater'
  | 'date.less'
  | 'date.max'
  | 'date.min'
  | 'date.format.iso'
  | 'date.format.javascript'
  | 'date.format.unix'
  | 'function.arity'
  | 'function.class'
  | 'function.maxArity'
  | 'function.minArity'
  | 'object.and'
  | 'object.assert'
  | 'object.base'
  | 'object.instance'
  | 'object.length'
  | 'object.max'
  | 'object.min'
  | 'object.missing'
  | 'object.nand'
  | 'object.oxor'
  | 'object.pattern.match'
  | 'object.refType'
  | 'object.regex'
  | 'object.rename.multiple'
  | 'object.rename.override'
  | 'object.schema'
  | 'object.unknown'
  | 'object.with'
  | 'object.without'
  | 'object.xor'
  | 'number.base'
  | 'number.greater'
  | 'number.infinity'
  | 'number.integer'
  | 'number.less'
  | 'number.max'
  | 'number.min'
  | 'number.multiple'
  | 'number.negative'
  | 'number.port'
  | 'number.positive'
  | 'number.precision'
  | 'number.unsafe'
  | 'string.alphanum'
  | 'string.base'
  | 'string.base64'
  | 'string.creditCard'
  | 'string.dataUri'
  | 'string.domain'
  | 'string.email'
  | 'string.empty'
  | 'string.guid'
  | 'string.hex'
  | 'string.hexAlign'
  | 'string.hostname'
  | 'string.ip'
  | 'string.ipVersion'
  | 'string.isoDate'
  | 'string.isoDuration'
  | 'string.length'
  | 'string.lowercase'
  | 'string.max'
  | 'string.min'
  | 'string.normalize'
  | 'string.token'
  | 'string.pattern.base'
  | 'string.pattern.name'
  | 'string.pattern.invert.base'
  | 'string.pattern.invert.name'
  | 'string.trim'
  | 'string.uri'
  | 'string.uriCustomScheme'
  | 'string.uriRelativeOnly'
  | 'string.uppercase'
  | 'symbol.base'
  | 'symbol.map';

type CustomValidationRules =
  | 'date.ageRestriction'
  | 'string.password'
  | 'custom.unique'
  | 'custom.recaptcha';

export type ValidationRule = JoiValidationRule | CustomValidationRules;

export type ValidationSource = 'headers' | 'params' | 'payload' | 'query';

export interface ValidationError {
  source: ValidationSource;
  message: string;
  path: (string | number)[];
  type: ValidationRule;
  context: Record<string, unknown>;
}
